import { render } from "./VueSelect.vue?vue&type=template&id=4c92642b"
import script from "./VueSelect.vue?vue&type=script&lang=js"
export * from "./VueSelect.vue?vue&type=script&lang=js"
script.render = render

export default script